<div class="container">
  <mat-card>
    <mat-card-header>
      <mat-card-title i18n>Allgemein</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-list>
        <mat-list-item>
          <div matListItemTitle i18n>Projektname</div>
          <div matListItemLine>{{ team.name }}</div>
        </mat-list-item>
        <mat-list-item>
          <div matListItemTitle i18n>Erstellt am</div>
          <div matListItemLine>{{ team.createdAt | date: 'short' }}</div>
        </mat-list-item>
        <mat-list-item>
          <div matListItemTitle i18n>Letzte Änderung</div>
          <div matListItemLine>{{ team.updatedAt | date: 'short' }}</div>
        </mat-list-item>
      </mat-list>
    </mat-card-content>
    <mat-card-actions>
      <div class="action-buttons">
        <button mat-raised-button color="warn" (click)="deleteTeam()" [hidden]="!isUserOwner" i18n>Projekt löschen</button>

        <div
          matTooltip="Als letztes echtes Teammitglied kannst Du das Team nur löschen."
          [matTooltipDisabled]="!isLastRealMember"
          i18n-matTooltip
        >
          <button mat-raised-button color="primary" (click)="leaveTeam()" [disabled]="isLastRealMember" i18n>Projekt verlassen</button>
        </div>
      </div>
    </mat-card-actions>
  </mat-card>

  <mat-card [dtOverlayProgress] #editRightProgress="dtOverlayProgress">
    <mat-card-header>
      <mat-card-title i18n>Bearbeitungsrecht</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="editRightForm" class="dt-form">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label i18n>Editoren können das Bearbeitungsrecht nehmen von</mat-label>
          <mat-select formControlName="canTakeEditRightFrom">
            <mat-option value="all" i18n>Allen</mat-option>
            <mat-option value="editor" i18n>Editoren</mat-option>
            <mat-option value="none" i18n>Niemandem</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field subscriptSizing="dynamic">
          <mat-label i18n>Das Bearbeitungsrecht verfällt automatisch für</mat-label>
          <mat-select formControlName="editRightExpiresFor">
            <mat-option value="all" i18n>Alle</mat-option>
            <mat-option value="editor" i18n>Editoren</mat-option>
            <mat-option value="none" i18n>Niemanden</mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </mat-card-content>
  </mat-card>
</div>
